import moment from 'moment-timezone';

function getReadableDate(dtstart, dtend) {
    let startDate = moment(dtstart, 'YYYYMMDD').tz('Europe/Vienna');
    // the subtraction seems like there's a timezone issue
    let endDate = moment(dtend, 'YYYYMMDD').tz('Europe/Vienna').subtract(1, 'days');
    if(startDate.isSame(endDate, 'date')) {
        return startDate.format('DD.MM.YYYY');
    } else if(startDate.isSame(endDate, 'month')) {
        return startDate.format('DD.') + ' - ' + endDate.startOf('day').format('DD.MM.YYYY');
    } else if(startDate.isSame(endDate, 'year')) {
        return startDate.format('DD.MM.') + ' - ' + endDate.format('DD.MM.YYYY');
    } else {
        return startDate.format('DD.MM.YYYY') + ' - ' + endDate.format('DD.MM.YYYY');
    }
}

window.workshopListInit = function () {
    return fetch('/calendar.json')
        .then(response => response.json())
        .then(data => {
            data = data.filter(el => {
                // full day events can be detected not having a time, future dates only
                return !el.dtstart.includes('T') && moment().tz('Europe/Vienna').isBefore(moment(el.dtstart, 'YYYYMMDD'));
            });
            data = data.sort((a, b) => a.dtstart - b.dtstart);
            let textArea = document.createElement('textarea');
            return data.map(el => {
                textArea.innerHTML = el.description;
                el.description = textArea.value.replace('\n', '<br>');
                el.date = getReadableDate(el.dtstart, el.dtend);
                return el;
            });
        });
}
